import categoryDetailsSymbols from "../symbols/categoryDetails";
import {
  HttpRegularPut,
  HttpRequestGet,
  HttpRegularDelete,
} from "../../service";
import { getCategoriesSymbols } from "./getCategories";
const categoryDetailsSymbolsAction = () => ({
  type: categoryDetailsSymbols.GET_CATEGORY_DETAILS,
});
const categoryDetailsSymbolsSuccessAction = (data: any) => ({
  type: categoryDetailsSymbols.GET_CATEGORY_DETAILS_SUCCESS,
  payload: data,
});
const categoryDetailsSymbolsFailureAction = (data: any) => ({
  type: categoryDetailsSymbols.GET_CATEGORY_DETAILS_FAILURE,
  payload: data,
});
const clearCategoryDetailsSymbolsAction = () => ({
  type: categoryDetailsSymbols.CLEAR_GET_CATEGORY_DETAILS,
});

export function getCategoryDetailsSymbols(id: string) {
  return (dispatch: any) => {
    dispatch(categoryDetailsSymbolsAction());
    HttpRequestGet(
      "/upc/category/" + id,
      dispatch,
      categoryDetailsSymbolsSuccessAction,
      categoryDetailsSymbolsFailureAction,
      true
    );
  };
}

export function updateCategoryDetails(
  id: string,
  body: any,
  failAction?: any,
  callback?: any
) {
  return (dispatch: any) => {
    HttpRegularPut("/upc/category/" + id, body, {
      dispatch: dispatch,
      actionSuccess: getCategoryDetailsSymbols,
      actionFailure: failAction,
      callback: callback,
    });
  };
}

export function clearCategorysSymbols() {
  return (dispatch: any) => {
    dispatch(clearCategoryDetailsSymbolsAction());
  };
}

export function removeCategoryDetails(
  id: string,
  failAction?: any,
  callback?: any
) {
  return (dispatch: any) => {
    HttpRegularDelete("/upc/category/" + id, {
      dispatch: dispatch,
      actionSuccess: getCategoriesSymbols,
      actionFailure: failAction,
      callback: callback,
    });
  };
}
